import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_7.module.css";
import Head from "next/head";
import Common_html from "./Common_html";

import BlockData from "../../../central-doctraine-json/chapter7.json";
export default function Chapter_7() {
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Jung/Pauli Conjecture | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-VII"
        ></meta>
        <meta
          property="og:title"
          content="Jung/Pauli Conjecture | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter7_OG_image_07_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration depicting the convergence of a intricate mandala and a quantum particle diagram, symbolizing the union of psychology and physics as explored in the Jung/Pauli Conjecture. The image blends symbols of the collective unconscious with scientific representations of energy and matter, all encompassed within a radiant light that signifies the presence and unity of the Divine Infinite Being."></meta>
        <meta
          property="og:description"
          content="The work of Jung and Pauli highlights the potential for interdisciplinary and transdisciplinary collaborations between psychology and quantum physics."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=6"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter7_OG_image_07_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration depicting the convergence of a intricate mandala and a quantum particle diagram, symbolizing the union of psychology and physics as explored in the Jung/Pauli Conjecture. The image blends symbols of the collective unconscious with scientific representations of energy and matter, all encompassed within a radiant light that signifies the presence and unity of the Divine Infinite Being."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=6"></meta>
        <meta name="twitter:title" content="Jung/Pauli Conjecture | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="The work of Jung and Pauli highlights the potential for interdisciplinary and transdisciplinary collaborations between psychology and quantum physics."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=7" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}
